import { Api } from './api';

// Create a single instance of Api to be used throughout the app
export const api = new Api(); 